import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { Instagram, ArrowRight } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    toast.success("Inscrição confirmada. Bem-vinda ao Ateliê.");
    setEmail("");
  };

  return (
    <footer data-testid="site-footer" className="bg-[#121212] text-[#F8F7F4] mt-28 overflow-hidden">
      {/* newsletter */}
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-20 border-b border-white/10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-end">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-4">Newsletter</div>
          <h3 className="font-serif font-light text-4xl md:text-5xl leading-tight">Receba nossas novidades<br />em primeira mão</h3>
        </div>
        <form onSubmit={subscribe} className="w-full">
          <div className="flex items-center border-b border-white/30 focus-within:border-[#B89C65] transition-colors">
            <input data-testid="newsletter-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Seu melhor e-mail"
              className="flex-1 bg-transparent outline-none py-4 text-[#F8F7F4] placeholder:text-[#F8F7F4]/40" />
            <button data-testid="newsletter-submit" className="text-[#F8F7F4] hover:text-[#B89C65] transition-colors"><ArrowRight size={22} strokeWidth={1.5} /></button>
          </div>
        </form>
      </div>

      {/* links */}
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-5">Loja</div>
          <ul className="space-y-3 text-[#F8F7F4]/70 text-sm">
            <li><Link to="/loja" className="hover:text-[#B89C65] transition-colors">Todos os produtos</Link></li>
            <li><Link to="/loja?cat=Vestidos" className="hover:text-[#B89C65] transition-colors">Vestidos</Link></li>
            <li><Link to="/loja?cat=Blazers" className="hover:text-[#B89C65] transition-colors">Blazers</Link></li>
            <li><Link to="/loja?cat=Tricô" className="hover:text-[#B89C65] transition-colors">Tricô</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-5">Atendimento</div>
          <ul className="space-y-3 text-[#F8F7F4]/70 text-sm">
            <li><Link to="/conta" className="hover:text-[#B89C65] transition-colors">Meus pedidos</Link></li>
            <li><span className="opacity-70">Trocas e devoluções</span></li>
            <li><span className="opacity-70">Guia de tamanhos</span></li>
            <li><span className="opacity-70">Fale conosco</span></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-5">A Marca</div>
          <ul className="space-y-3 text-[#F8F7F4]/70 text-sm">
            <li><span className="opacity-70">Nossa história</span></li>
            <li><span className="opacity-70">Sustentabilidade</span></li>
            <li><span className="opacity-70">Lojas físicas</span></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#B89C65] mb-5">Social</div>
          <a href="#" className="inline-flex items-center gap-2 text-[#F8F7F4]/70 hover:text-[#B89C65] transition-colors text-sm">
            <Instagram size={18} strokeWidth={1.5} /> @atelie
          </a>
        </div>
      </div>

      {/* giant wordmark */}
      <div className="px-5 md:px-10 select-none pointer-events-none">
        <div className="font-serif font-light text-[22vw] leading-[0.8] tracking-tight text-white/[0.06] -mb-[3vw]">ATELIÊ</div>
      </div>

      <div className="border-t border-white/10 py-6 px-5 md:px-10 flex flex-col md:flex-row justify-between items-center gap-3 text-[#F8F7F4]/40 text-xs">
        <span>© {new Date().getFullYear()} Ateliê. Todos os direitos reservados.</span>
        <span className="uppercase tracking-[0.15em]">Feito no Brasil</span>
      </div>
    </footer>
  );
}
